import type { Data } from '@repo/strapi-types'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { Tooltip } from '@/components/elementary/Tooltip'
import { Info } from '@/components/icons/Info'
import { HighlightIcon } from '@/components/page-builder/global/pricingV1/overview/HighlightIcon'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'
import styles from '../featureComparison/FeatureCell.module.css'

export function PlanHighlights({
	pricingItem,
	yearly,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-plan-detail'> | null
	yearly?: boolean
	className?: string
}) {
	const highlights = yearly ? pricingItem?.highlightsYearly : pricingItem?.highlightsMonthly
	return (
		<div className={cn('flex flex-col gap-4.5 py-5 px-3.75', className)}>
			{pricingItem?.highlightsTitle && (
				<Paragraph fontSize="bodyBoldMedium" className="text-neutral-light-100">
					{pricingItem?.highlightsTitle}
				</Paragraph>
			)}

			{highlights?.map((highlight) => {
				if (!highlight) return null
				return (
					<div key={highlight.id} className="flex items-start">
						<HighlightIcon icon={highlight.icon} />

						<CkEditorCSRRenderer
							htmlContent={highlight.text}
							className={styles['table-cell-content']}
							defaultTypography="bodyMedium"
						/>

						{highlight.tooltip ? (
							<Tooltip content={highlight.tooltip}>
								<span>
									<Info className="text-neutral-light-400 size-4 top-1 relative shrink-0 ml-1" />
								</span>
							</Tooltip>
						) : null}
					</div>
				)
			})}
		</div>
	)
}
